import renderInlineItalic from 'lib/utils/renderInlineItalic';
import Image from 'components/shared/image/image';
import RichText from 'components/shared/richtext';
import VideoPlayer from 'components/shared/video/video';
import classNames from 'classnames';
import Button from 'components/shared/button/button';
import styles from './textAndMedia.module.scss';

const TextAndMedia = ({ data, locale }) => {
  const { title, titleFont, body, button, media, mediaPosition, contentAlignment, anchorId } = data;
  const titleClass = classNames(styles.title, titleFont !== 'Acumin Pro' && styles.octave);

  return (
    <section id={anchorId}>
      <div className={classNames(styles.wrapper, { [styles.reversed]: mediaPosition === 'Right' })}>
        <div className={styles.mediaContainer}>
          {media.type === 'Image' && (
            <Image
              className={styles.media}
              src={media.image}
              loading="lazy"
              layout="responsive"
              sizes="(max-width: 899px) 100vw, 50vw"
            />
          )}
          {media.type === 'Video' && media.video && (
            <VideoPlayer
              className={classNames(styles.media)}
              thumbnail={media.thumbnail}
              source={media.video}
              controlsVersion={2}
              aspectRatio={media.videoAspectRatio}
              objectFit={media.objectFit}
              focalPoint={media.focalPoint}
            />
          )}
        </div>
        <div
          className={classNames(styles.content, {
            [styles.alignCenter]: contentAlignment === 'Center',
            [styles.alignBottom]: contentAlignment === 'Bottom',
          })}
        >
          {title && <h2 className={titleClass}>{renderInlineItalic(title)}</h2>}
          <RichText className={classNames(styles.text)} text={body?.json} />
          <Button className={classNames(styles.button)} locale={locale} button={button} />
        </div>
      </div>
    </section>
  );
};

export default TextAndMedia;
